var EncryptAppspaceTemplate = require('./encrypt-appspace.template.js');
module.exports = EncryptAppspace = {
  render: function render(app, data) {
    document.querySelector('.email-appspace').innerHTML = EncryptAppspaceTemplate();
  },
  attachEvents: function attachEvents(app, data) {
    document.querySelector('.email-submit').addEventListener('click', function (e) {
      var recipient = document.getElementById('email-to-address').value;
      data.email.appspace_mod.initiate_key_exchange(recipient);
    });
  }
};